
import Category from "@/types/Category";
import { useForm } from "@inertiajs/inertia-vue3";
import dayjs from "dayjs";
import { computed, defineComponent, PropType, ref } from "vue";
import ButtonGroup from "../Buttons/ButtonGroup.vue";
import Multiselect from "../General/Multiselect.vue";
import Button from "../Buttons/Button.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiLoading } from "@mdi/js";
import CategorySelect from "../Forms/CategorySelect.vue";

export default defineComponent({
  props: {
    defaultCategories: {
      type: Array as PropType<number[]>,
      required: true,
    },
    defaultDateFrom: {
      type: String,
      required: true,
    },
    defaultDateTo: {
      type: String,
      required: true,
    },
    defaultExcludeWeborders: {
      type: Boolean,
      default: () => false,
    },
    allCategories: {
      type: Array as PropType<Category[]>,
      required: true,
    }
  },
  setup(props) {
    const visibleCategory = ref(props.allCategories[0].id);

    const form = useForm({
      categories: props.defaultCategories,
      date_from: props.defaultDateFrom,
      date_to: props.defaultDateTo,
      exclude_web_orders: props.defaultExcludeWeborders,
    });

    const submit = () => {
      form.get(route(route().current() ?? ""));
    };

    const categories = computed((): Category[] => {
      const categories = JSON.parse(JSON.stringify(props.allCategories));

      categories.forEach((main: Category) => {
        main.children?.unshift({
          id: main.id,
          label: main.label,
          parent: 0,
          type: "category",
        });
      });

      return categories;
    });

    return {
      form,
      submit,
      categories,
      visibleCategory,
      icons: {
        loading: mdiLoading,
      }
    };
  },
  components: { ButtonGroup, Multiselect, Button, SvgIcon, CategorySelect }
});
